import { type ReactNode } from 'react';

import { UnauthorizedPage } from '@/features/system/pages/unauthorized-page';

import { useCurrentUser } from '../auth-context';
import { hasRole } from '../permissions';
import type { AppRole } from '../types';

/** Route-level role gate (UX only — the server enforces the same rule). */
export function RequireRole({
  roles,
  children,
}: {
  roles: readonly AppRole[];
  children: ReactNode;
}) {
  const { profile } = useCurrentUser();
  if (!hasRole(profile.role, roles)) return <UnauthorizedPage />;
  return <>{children}</>;
}
